import React, { FC } from 'react'

import { EuiButton, EuiFlexGroup, EuiFlexItem, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeaderTitle, EuiText } from '@elastic/eui'
import { ButtonColor } from '@elastic/eui/src/components/button/button'

export interface AgencyV2ModalProps {
  isLoading: boolean
  title: string
  onClose: () => void
  confirmButtonText: string
  onConfirmButtonClick: () => void
  confirmButtonDisabled?: boolean
  confirmButtonColor?: ButtonColor
  confirmButtonFilled?: boolean
  showCancelButton?: boolean
  onCancelButtonClick?: () => void
  bodyHeight?: string
}

const AgencyV2Modal: FC<AgencyV2ModalProps> = ({ isLoading, title, onClose, confirmButtonText, onConfirmButtonClick, confirmButtonDisabled, confirmButtonColor, confirmButtonFilled, showCancelButton, onCancelButtonClick, bodyHeight, children }) => {
  return (
    <EuiModal onClose={onClose} style={{ minWidth: '40em' }}>
      <EuiModalHeaderTitle style={{ paddingTop: '1em', paddingLeft: '1em' }}>{title}</EuiModalHeaderTitle>
      <EuiModalBody style={{ paddingLeft: '1.5em', paddingTop: '1em', height: bodyHeight }}>{children}</EuiModalBody>
      <EuiModalFooter>
        <EuiFlexGroup>
          <EuiFlexItem />
          {!showCancelButton && <EuiFlexItem grow={3} />}
          {showCancelButton && (
            <EuiFlexItem grow={3}>
              <EuiButton isDisabled={isLoading} onClick={onCancelButtonClick ?? onClose}>
                Cancel
              </EuiButton>
            </EuiFlexItem>
          )}
          <EuiFlexItem grow={3}>
            <EuiButton isLoading={isLoading} fill={confirmButtonFilled === undefined ? true : confirmButtonDisabled} onClick={onConfirmButtonClick} color={confirmButtonColor} disabled={confirmButtonDisabled}>
              {confirmButtonText}
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiModalFooter>
    </EuiModal>
  )
}

export default AgencyV2Modal
